// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"fc9583c9","874":"dfb5500a"}[chunkId] + ".chunk.js";
};